import { render } from "./PromoVideo.vue?vue&type=template&id=5feb2b90&scoped=true"
const script = {}

import "./PromoVideo.vue?vue&type=style&index=0&id=5feb2b90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5feb2b90"]])

export default __exports__